import React from 'react';
import Sidebar from '../sidebar';
import LeasesContent from './LeasesContent';

export default function Leases(): JSX.Element {
  return (
    <div style={{ display: 'flex' }}>
      <Sidebar variant='main' activeLink='leases' />
      <LeasesContent />
    </div>
  );
}
